import {SITE_NAME, SITE_STORAGE_VERSION} from "../constants";

export class StorageService {
	constructor() {
		this.siteName = SITE_NAME;
		this.version = SITE_STORAGE_VERSION;

		this.initVersion();
	}

	initVersion() {
		if (!this.siteName) console.error("Не укзан SITE_NAME!");
		this.getItem("version").then(res => {
			if (!res || res !== this.version) {
				this.clear();
				return this.setItem("version", this.version);
			}
		});
	}

	setItem(key, value) {
		return localforage.setItem(this.siteName + "_" + key, value);
	}

	getItem(key) {
		return localforage.getItem(this.siteName + "_" + key);
	}

	removeItem(key) {
		return localforage.removeItem(this.siteName + "_" + key);
	}

	clear() {
		return localforage.clear();
	}
}
